import { replenishmentClient } from "Clients";

export const cancelReplenishmentOrder = async (orderId: string) => {
  await replenishmentClient.cancelOrder(orderId);
};
